import Field from '../form/field';

export default class FormCheckbox extends Field {

  constructor ($el) {
    super($el, 'form-checkbox');

    // Bind elements
    this.$input = $el.querySelector(`.${this.classname}__input`);

    // Get field name and original help text (replaced by validation message)
    this.name = this.$input.name;

    // Bind events and call initial change event
    this.$input.onfocus = this.onFocus.bind(this);
    this.$input.onblur = this.onBlur.bind(this);
    this.$input.oninput = this.onChange.bind(this);
    this.onChange();
  }

  getValue () {
    return this.isHidden ? '' : this.$input.checked;
  }
}
